import {LeftArrowOutlined, RightArrowOutlined} from '@web/assets/icons';
import {Button, Divider} from 'antd';
import PropTypes from 'prop-types';

AppFooter.propTypes = {
  index: PropTypes.number,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  onSkip: PropTypes.func,
  onExit: PropTypes.func,
  nextText: PropTypes.string,
  prevText: PropTypes.string,
  hide: PropTypes.bool,
}

function AppFooter(props) {
  return props.hide ?
    <div style={{height: 100}}>
      <div className="space space-center-y space-between">
        {!!props.onPrev && props.index > 0 ?
          <Button ghost size="large" shape="circle" className="icon-btn" onClick={() => props.onPrev()}>
            <LeftArrowOutlined className="musted-icon" />
            <span className="space space-center-y green-color">{props.prevText || ""}</span>
          </Button> : <div/>}
        {props.onSkip && <Button size="large" ghost onClick={props.onSkip}><span className="muted">Later</span></Button>}
      </div>
    </div> :
    <div style={{height: 100}}>
      <Divider/>
      <div className="space space-center-y space-between">
        <div className="space space-center-y">
          {!!props.onPrev && props.index > 0 &&
            <Button ghost size="large" shape="circle" className="icon-btn" onClick={() => props.onPrev()}>
              <LeftArrowOutlined className="musted-icon" />
              <span className="space space-center-y green-color">{props.prevText || ""}</span>
            </Button>}
          <Button size="large" shape="round"  className="icon-btn" onClick={() => props.onNext()}>
            <span className="space space-center-y green-color">{props.nextText || "Next"}</span>
            <RightArrowOutlined className="green-icon"/>
          </Button>
        </div>
        <div>
          {props.onSkip && <Button size="large" ghost onClick={props.onSkip}><span className="muted">Later</span></Button>}
          {props.onExit && <Button size="large" ghost onClick={props.onExit}><span className="muted">Exit</span></Button>}
        </div>
      </div>
    </div>
}

export default AppFooter;
